let $ = require("jquery");
let _ = require("underscore");
let Backbone = require("backbone");
let DiscountCollection = require("./collection/DiscountCollection.js");
import MenuCategoryCollection from "./collection/MenuCategoryCollection.js";

let MenuItemCollection = require("./collection/MenuItemCollection.js");
let RestaurantModel = require("./model/RestaurantModel.js");
let tableCollection = require("./collection/TableCollection.js");
let BillItemCollection = require("./collection/BillItemCollection.js");
let BillModel = require("./model/BillModel.js");
let BillItemModel = require("./model/BillItemModel.js");
let TableModel = require("./model/TableModel.js");
let NotificationCollection = require("./collection/NotificationCollection.js");
let NotificationModel = require("./model/NotificationModel.js");
let PrintSettingModel = require("./model/settings/PrintSettingModel.js");
import MenuModel from "./model/MenuModel.js";

let MenuTagModel = require("./model/MenuTagModel.js");
let MenuTagCollection = require("./collection/MenuTagCollection.js");
let DbRecorder = require("./recorder/DbRecorder.js");
let {uuid} = require("./utils/utils.js");
import queryParser from "query-string";

let main = function () {
    var POS = Backbone.Model.extend({

        url: '/pos/setup',

        defaults: {
            rId: null,
            username: null,
            discountCollection: null,
            tableCollection: null,
            notificationCollection: null,
            restaurantModel: null,
            PrinterConverterUtil: null,
            PrinterUtil: null,
            printSettingModel: null,
            menuModel: new MenuModel(),
            status: new Backbone.Model(),
            syncStatus: new Backbone.Model(),
            tableSpace: 3,
            refreshTime: (function () {
                return new Date().getTime()
            })(),
            mark: (function () {
                return new Date().getTime()
            })(),
            deviceId: null,
            menuItemBytesmap: {},
            menuCatBytesmap: {},
            environment: null,
            syncInitialised: false, //used by BillRecord to show that sync with server at init is completed or not
            tagsBytesmap: {},
            sendLogFlag: false,
            restaurantAdmins: null,
            cloudPrintSettings: [],
            tablePaidSum: 0,
            tableUnpaidSum: 0,
            tableClosedSum: 0

        },

        duplicate: false,
        hideConfirm: false,

        _getLang: function () {
            const params = queryParser.parse(window.location.search);
            return params.lang;
        },

        setup: function (params) {
            var deferred = $.Deferred();
            if (typeof(Notification) !== 'undefined' && Notification.permission !== "granted") {
                Notification.requestPermission();
            }
            var self = this, jxhr, mark;

            if (!self.isCurrentClientValid()) {
                alert("您已经在本浏览器打开朵颐");
                return deferred.resolve();
            }
            mark = self.generateMark();
            self.set({deviceId: self.getDeviceId()});
            console.time('pos-load-data');
            jxhr = $.post("/pos/setup", {mark: mark, menuLastUpdated: localStorage.getItem('menuLastUpdated'),
                menuId: localStorage.getItem('menuId')});
            jxhr.done(function (response) {
                console.timeEnd('pos-load-data');
                console.time('pos-setup');

                self.set(response);

                if (response.bytes) {
                    console.time('pos-parsebytes');
                    self.set({bytes: JSON.parse(response.bytes)});
                    console.timeEnd('pos-parsebytes');
                }

                if (response.cloudPrintSettings) {
                    try {
                        self.set({cloudPrintSettings: JSON.parse(response.cloudPrintSettings)});
                    } catch (e) {
                        // ignore e
                        console.log(new Date() + " unable to parse cloud print settings: " + e);
                        self.set({cloudPrintSettings: []});
                    }
                } else {
                    self.set({cloudPrintSettings: []});
                }
                console.timeEnd('pos-cloudsetting');
                console.time('pos-menu');
                var cateList;

                if (self.get('menuCategories')) {
                    localStorage.setItem("menu", self.get('menuCategories'));
                    localStorage.setItem("menuId", response.menuId);
                    localStorage.setItem("menuLastUpdated", new Date().getTime());

                } else {
                    let localMenu = localStorage.getItem('menu');

                    if (localMenu) {
                        console.log('using local cached menu');
                        cateList = localStorage.getItem('menu');
                        self.set('menuCategories', cateList);

                    } else {
                        localStorage.setItem("menu", null);
                        localStorage.setItem("menuLastUpdated", 0);
                        console.error("missing menu data!");
                        alert("本地菜单缓存已被清除，请刷新页面获取新菜单");
                    }

                }

                cateList = JSON.parse(self.get('menuCategories'));
                cateList.forEach(function (category, index) {
                    //      保存菜单id
                    if (index == 0) {
                        self.set({menuid: category.menuId});
                    }
                    if (category.tempCategory) {
                        cateList.splice(index, 1);
                    }
                });
                // console.log("cateList:",cateList);
                // self.getMenu().setCategories(new MenuCategoryCollection(JSON.parse(self.get('menuCategories'))));
                self.getMenu().setCategories(new MenuCategoryCollection(cateList));
                console.time('pos-menubytes');
                self.getMenu().getCategories().forEach(function (category) {
                    _.each(category.get("items"), function (item) {
                        item.category = {id: category.id, name: category.get("name")};
                        self.get("menuItemBytesmap")[item.id] = item.bytesmap;
                    });
                    category.setMenuItems(new MenuItemCollection(category.get("items")));

                    //为MenuCategory设置Tags
                    if (_.isArray(category.get("tags"))) {
                        _.each(category.get("tags"), function (tag) {
                            self.get("tagsBytesmap")[tag.id] = tag.bytes;
                        });
                    }
                    category.setTags(new MenuTagCollection(category.get("tags")));
                    //为MenuCategory中的每个MenuItem设置Tags
                    category.getMenuItems().each(function (item) {
                        if (_.isArray(item.get("tags"))) {
                            _.each(item.get("tags"), function (tag) {
                                self.get("tagsBytesmap")[tag.id] = tag.bytes;
                            });
                        }
                        item.setTags(new MenuTagCollection(item.get("tags")));
                    });
                });
                console.time('pos-menubytes');
                console.timeEnd('pos-menu');

                self.set({
                    discountCollection: new DiscountCollection(self.get("dataDiscounts"))
                });


                self.set({
                    "notificationCollection": new NotificationCollection(self.get("notifications"))
                });

                console.time('pos-table');
                $.each(self.get("tables"), function (index, _table) {
                    const table = new TableModel(_table);
                    table.refreshStatus();
                    tableCollection.push(table);
                });
                console.timeEnd('pos-table');

                self.set({
                    "tableCollection": tableCollection
                });
                self.refreshTableStatus();

                self.set({"restaurantModel": new RestaurantModel(self.get("restaurant"))});

                self.set({"printSettingModel": new PrintSettingModel(self.get("printSetting"))});

                if (self.get("restaurantModel").get("sendLog") == true) {
                    self.sendLogFlag = true;
                }
                deferred.resolve(response);
                console.timeEnd('pos-setup');
            });

            jxhr.fail(function (response) {
                console.log(response);
                deferred.reject();
            });
            return deferred;
        },
        refreshTableStatus() {
            let unpaid = 0, paid = 0, close = 0, self = this;
            this.getTables().each((table) => {
                const hasUnpaid = table.getBillCollection().find((b) => {
                    return !b.hasPaid();
                }) != null;
                if (table.getStatus() == 'Unpaid' || hasUnpaid) {
                    unpaid++;
                } else if (table.getStatus() == 'Paid') {
                    paid++;
                } else {
                    close++;
                }
            });
            this.set({
                "tablePaidSum": paid
            });
            this.set({
                "tableUnpaidSum": unpaid
            });
            this.set({
                "tableClosedSum": close
            });
        },
        showLoading: function (isShown) {
            if (isShown) {
                $('#bigLoading').removeClass('hidden');
            } else {
                $('#bigLoading').addClass('hidden');
            }
        },
        getBytes: function (value, type) {
            switch (type) {
                case 'code':
                    return _.findWhere(this.get("bytes") || [], {code: value});
                    break;
                default :
                    return _.findWhere(this.get("bytes") || [], {text: value});
                    break;
            }
        },

        getCodeBytes: function (code) {
            return this.getBytes(code, "code");
        },

        getMenuItemBytes: function (id) {
            return this.get("menuItemBytesmap")[id];
        },
        getMenuCatBytes: function (id) {
            return this.get("menuModel").get('categories').findWhere({id: parseInt(id)}).get("bytesmap");
        },
        getTagsBytes: function (id) {
            return this.get("tagsBytesmap")[id];
        },
        /**
         * an object containing the current user's id, email and username
         * @returns {*}
         */
        getUser: function () {
            return this.get('user');
        },

        /**
         * 看 Restaurant.groovy 的 toMap 方法可得知JS Model里面有的数据
         *
         * @returns {*}
         */
        getRestaurant: function () {
            return this.get("restaurantModel");
        },

        getPrinterSetting: function () {
            return this.get("printSettingModel");
        },

        getNotifications: function () {
            return this.get("notificationCollection");
        },

        getTables: function () {
            return this.get("tableCollection");
        },

        getTable: function (id) {
            return this.getTables().get(id);
        },

        getBills: function () {
            var self = this, bills = new Backbone.Collection();
            _.each(DbRecorder.search(self.getTables()), function (model) {
                if (model instanceof BillModel) {
                    bills.add(model);
                }
            });
            return bills;
        },

        getTableOfBill: function (billId) {
            return this.getTables().find(function (t) {
                var bills = t.getBillCollection();
                var currentBill = t.getCurrentBill();
                return currentBill && currentBill.id == billId ? currentBill : bills.get(billId);
            });
        },

        getCloudPrintSettings: function () {
            return this.get("cloudPrintSettings");
        },

        setCloudPrintSettings: function (settings) {
            this.set({cloudPrintSettings: settings});
        },

        getUseCloudPrint: function () {
            return this.get('useCloudPrint');
        },

        setCurrentTable: function (table) {
            table ? this.set({currentTable: table}) : this.unset("currentTable");
        },

        getCurrentTable: function () {
            return this.get("currentTable");
        },

        getMenu: function () {
            return this.get('menuModel');
        },

        getRestaurantAdmins: function () {
            return this.get('restaurantAdmins');
        },

        checkBillAmount: function () {
            var billAmountStatus = 0;
            this.get("tableCollection").each(function (it) {
                billAmountStatus += it.getBillCollection().length
            });
            return billAmountStatus;
        },
        getOrderingTables: function () {
            return _.filter(this.getTables().models, function (model) {
                return !model.getCurrentBill().isPaid() && model.getCurrentBill().getBillItems().length > 0;
            });
        },

        getRefreshTime: function () {
            return this.get("refreshTime");
        },

        checkFeature: function (feature) {
            var result = false;
            _.forEach(this.get("availableFeatures"), function (item) {
                if (item == feature) {
                    result = true;
                }
            });
            return result;
        },

        getStatus: function () {
            return this.get("status");
        },
        getSyncStatus: function () {
            return this.get('syncStatus');
        },
        isCurrentClientValid: function () {
//                var mark = DbRecorder.read("mark");
//                if (mark) {
//                    this.duplicate = true;
//                }
//                return !mark;
            return true;
        },
        generateMark: function () {
            var mark = "mark_" + Math.ceil(Math.random() * 100000);
            DbRecorder.save("mark", mark);
            return mark;
        },
        markDuplicate: function () {
            this.duplicate = true;
        },
        clearMark: function () {
            var self = this, jxhr,
                restaurant = self.getRestaurant(),
                mark = DbRecorder.read('mark');
            if (!this.duplicate) {
                DbRecorder.remove("mark");
                $.post("/pos/quit", {restaurantId: restaurant ? restaurant.id : 0, mark: mark});
            }

        },
        makeHideConfirm: function () {
            this.hideConfirm = true;
        },
        shouldConfirmLeave: function () {
            return !this.duplicate && !this.hideConfirm;
        },
        getDeviceId: function () {
            let deviceId = DbRecorder.read("device-id");
            if (!deviceId) {
                deviceId = uuid();
                DbRecorder.saveNow("device-id", deviceId);
            }
            return deviceId;
        },
        setTablePaidSum: function (tablePaid) {
            this.set("tablePaidSum", tablePaid);
        },
        setTableUnpaidSum: function (sum) {
            this.set("tableUnpaidSum", sum);
        },
        setTableClosedSum: function (sum) {
            this.set("tableClosedSum", sum);
        },
    });
    const pos = new POS();
    window.POS = pos;
    return pos;
};

let exportedValue = main();
export default exportedValue;


// WEBPACK FOOTER //
// ./src/POS.js